import { ArrowRight } from 'lucide-react'
import { PageHero } from '../components/PageHero'
import { PageMeta } from '../components/PageMeta'

export function AboutPage() {
  return (
    <main id="main-content" className="route-page">
      <PageMeta
        title="About Informat"
        description="Informat Limited is an established, owner-led Irish technology consultancy combining practical business technology with senior enterprise experience."
      />
      <PageHero
        className="about-hero editorial-hero"
        title={
          <>
            Senior judgement. Directly involved.
            <span className="text-cursor" aria-hidden="true" />
          </>
        }
        body="Informat Limited is an established, owner-led Irish technology consultancy based in Gorey, County Wexford."
        primary={{ href: '/contact', label: 'Start a conversation' }}
        visual={
          <blockquote>
            <p>The person who scopes the work stays close to the work.</p>
            <cite>Technology, quietly mastered.</cite>
          </blockquote>
        }
      />
      <section className="about-story section-light">
        <div data-reveal>
          <h2>Business technology with enterprise depth.</h2>
        </div>
        <div data-reveal>
          <p>
            Informat helps organisations design, improve, secure, automate, migrate and document the
            technology they rely on.
          </p>
          <p>
            The work spans practical small-business environments and technically complex Microsoft
            estates. That combination brings strong architecture and security judgement to everyday
            business needs without introducing unnecessary complexity.
          </p>
        </div>
      </section>
      <section className="about-values section-dark" aria-labelledby="about-values-title">
        <h2 id="about-values-title" data-reveal>
          What clients can expect.
        </h2>
        <div>
          <article data-reveal>
            <span>01</span>
            <h3>Plain language</h3>
            <p>Technology explained in terms of decisions, responsibilities, risks and outcomes.</p>
          </article>
          <article data-reveal>
            <span>02</span>
            <h3>Considered delivery</h3>
            <p>Work shaped around the environment instead of a one-size-fits-all product answer.</p>
          </article>
          <article data-reveal>
            <span>03</span>
            <h3>Useful handover</h3>
            <p>Documentation and ownership that remain valuable after the project is complete.</p>
          </article>
        </div>
      </section>
      <section className="closing-cta section-light closing-cta--light">
        <div>
          <h2>Talk directly about what your business needs.</h2>
          <p>No need to diagnose the technology before getting in touch.</p>
        </div>
        <a href="/contact">
          Discuss a project <ArrowRight aria-hidden="true" />
        </a>
      </section>
    </main>
  )
}
